import { HttpClient } from "@angular/common/http";
import { Injector } from "@angular/core";
import { WorkspaceBase } from "../../workspace-base/workspace-base";
import { AppServiceHelperService } from "../../../../services/app-service-helper.service";
import { EventBusService } from "../../../../services/event-bus.service";

/**
 * Grid action handler. Use this class to listen to events and perform an action.
 * Reister them in the workspace by returning them inside the actionHandlers getter
 */
export abstract class GridActionHandlerBase {
  /**
   * The EventBusService 
   */
  protected eventBus: EventBusService;

  /**
   * The AppServiceHelperService
   */
  protected appServiceHelper: AppServiceHelperService;

  /**
  * The Angular HttpClient
  */
  protected http: HttpClient;

  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(protected injector: Injector, protected workspace: WorkspaceBase, public topic: string) {
    this.eventBus = this.injector.get(EventBusService);
    this.http = this.injector.get(HttpClient);
    this.appServiceHelper = this.injector.get(AppServiceHelperService);
  }
  /**
   * Handles an event
   * @param payload The (untyped) payload. Can also be a callback function
   */
  public abstract handle(payload: any): void;
}
